<template>
  <div>
    <div v-if="data">
      <parsed-panel v-if="data.dataType === 1" :data="data"/>
      <parsed-sport-panel v-if="data.dataType === 2" :data="data"/>
    </div>

    <div v-if="!data">{{ hint }}</div>
  </div>
</template>

<script>
import ParsedPanel from './ParsedPanel.vue'
import ParsedSportPanel from './ParsedSportPanel.vue'
import { parse } from '@/services/MhnService'

export default {
  components: {
    ParsedPanel,
    ParsedSportPanel
  },
  data () {
    return {
      data: null,
      hint: 'loading...'
    }
  },
  mounted: async function () {
    try {
      const objId = this.$route.query.objId
      const project = this.$route.query.project
      const res = await parse(objId, 0, project)
      console.log(res.data)
      if (res.data.result) {
        this.data = res.data.result
      } else {
        this.hint = 'no data!'
      }
    } catch (err) {
      console.error(err)
      this.hint = 'no data!'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Parsemhn.vue